import { hideableLayoutContextMenuItems, hideableLayoutFunc } from './hideable-layout.js';

const nodesConfig = {
	tagName: 'HideableLayout',
	key: 'nodesHideableLayout',
	contextMenuItems: hideableLayoutContextMenuItems,
	func: hideableLayoutFunc,
	title: { desc: 'Sankey14', name: 'Nodes' },
	children: [
		{
			tagName: 'Text',
			text: { desc: 'Sankey26', name: 'Density' }
		},
		{
			tagName: 'HorizontalLayout',
			className: 'two-to-one-layout',
			children: [
				{
					tagName: 'Select',
					key: 'densityMode',
					options: [
						{ name: { desc: 'Sankey15', name: 'Auto' }, value: 'auto' },
						{ name: { desc: 'Sankey16', name: 'Fixed' }, value: 'fixed' }
					]
				},
				{
					tagName: 'InputNumber',
					key: 'density',
					showStepper: true,
					value: 0,
					min: 0,
					applyChangeOnFocusOut: false
				}
			]
		},
		{ tagName: 'Divider' }
	]
};

export default nodesConfig;
